// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operator-kpi-card {
  --kpi-accent: #2563eb;
  --kpi-soft: rgba(37, 99, 235, 0.11);
  position: relative;
  overflow: hidden;
  min-width: 0;
  min-height: 152px;
  padding: 17px 17px 15px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 20px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(248, 250, 252, 0.94));
  box-shadow: 0 12px 34px rgba(15, 23, 42, 0.065);
  animation: operator-kpi-enter 520ms ease both;
  animation-delay: var(--operator-kpi-delay);
  transition: transform 220ms ease, box-shadow 220ms ease;
}
.operator-kpi-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 42px rgba(15, 23, 42, 0.11);
}
.operator-kpi-card strong {
  display: block;
  position: relative;
  z-index: 2;
  margin-top: 7px;
  color: #0f172a;
  font-size: clamp(21px, 1.8vw, 29px);
  font-weight: 850;
  line-height: 1;
  letter-spacing: -0.8px;
  white-space: nowrap;
}
.operator-kpi-card small {
  display: block;
  position: relative;
  z-index: 2;
  margin-top: 4px;
  overflow: hidden;
  color: #64748b;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.operator-kpi-card--indigo {
  --kpi-accent: #4f46e5;
  --kpi-soft: rgba(79, 70, 229, 0.11);
}

.operator-kpi-card--cyan {
  --kpi-accent: #0891b2;
  --kpi-soft: rgba(8, 145, 178, 0.11);
}

.operator-kpi-card--blue {
  --kpi-accent: #2563eb;
  --kpi-soft: rgba(37, 99, 235, 0.11);
}

.operator-kpi-card--green {
  --kpi-accent: #059669;
  --kpi-soft: rgba(5, 150, 105, 0.11);
}

.operator-kpi-card--purple {
  --kpi-accent: #7c3aed;
  --kpi-soft: rgba(124, 58, 237, 0.11);
}

.operator-kpi-card--red {
  --kpi-accent: #dc2626;
  --kpi-soft: rgba(220, 38, 38, 0.1);
}

.operator-kpi-card__top {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.operator-kpi-card__eyebrow {
  color: var(--kpi-accent);
  font-size: 14px;
  font-weight: 850;
  letter-spacing: 1.15px;
}

.operator-kpi-card__icon {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 11px;
  background: var(--kpi-soft);
  color: var(--kpi-accent);
}
.operator-kpi-card__icon svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.operator-kpi-card__label {
  display: block;
  position: relative;
  z-index: 2;
  margin-top: 8px;
  color: #475569;
  font-size: 13px;
  font-weight: 650;
}

.operator-kpi-card__glow {
  position: absolute;
  width: 120px;
  height: 120px;
  right: -48px;
  bottom: -62px;
  border-radius: 50%;
  background: var(--kpi-soft);
  filter: blur(4px);
}

@keyframes operator-kpi-enter {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/Dashboard/operator-utilization/components/OperatorUtilizationKpiCard.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,mCAAA;EAEA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,2CAAA;EACA,mBAAA;EACA,yFACE;EACF,+CAAA;EACA,6CAAA;EACA,0CAAA;EACA,uDACE;AAFJ;AAKE;EACE,2BAAA;EACA,8CAAA;AAHJ;AAME;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,mCAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AAJJ;AAOE;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AALJ;;AASA;EACE,qBAAA;EACA,mCAAA;AANF;;AASA;EACE,qBAAA;EACA,mCAAA;AANF;;AASA;EACE,qBAAA;EACA,mCAAA;AANF;;AASA;EACE,qBAAA;EACA,mCAAA;AANF;;AASA;EACE,qBAAA;EACA,oCAAA;AANF;;AASA;EACE,qBAAA;EACA,kCAAA;AANF;;AASA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AANF;;AASA;EACE,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,wBAAA;AANF;AAQE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AANJ;;AAUA;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAPF;;AAUA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA;AAPF;;AAUA;EACE;IACE,UAAA;IACA,2BAAA;EAPF;EAUA;IACE,UAAA;IACA,wBAAA;EARF;AACF","sourcesContent":[".operator-kpi-card {\n  --kpi-accent: #2563eb;\n  --kpi-soft: rgba(37, 99, 235, 0.11);\n\n  position: relative;\n  overflow: hidden;\n  min-width: 0;\n  min-height: 152px;\n  padding: 17px 17px 15px;\n  border: 1px solid rgba(148, 163, 184, 0.18);\n  border-radius: 20px;\n  background:\n    linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(248, 250, 252, 0.94));\n  box-shadow: 0 12px 34px rgba(15, 23, 42, 0.065);\n  animation: operator-kpi-enter 520ms ease both;\n  animation-delay: var(--operator-kpi-delay);\n  transition:\n    transform 220ms ease,\n    box-shadow 220ms ease;\n\n  &:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 20px 42px rgba(15, 23, 42, 0.11);\n  }\n\n  strong {\n    display: block;\n    position: relative;\n    z-index: 2;\n    margin-top: 7px;\n    color: #0f172a;\n    font-size: clamp(21px, 1.8vw, 29px);\n    font-weight: 850;\n    line-height: 1;\n    letter-spacing: -0.8px;\n    white-space: nowrap;\n  }\n\n  small {\n    display: block;\n    position: relative;\n    z-index: 2;\n    margin-top: 4px;\n    overflow: hidden;\n    color: #64748b;\n    font-size: 13px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.operator-kpi-card--indigo {\n  --kpi-accent: #4f46e5;\n  --kpi-soft: rgba(79, 70, 229, 0.11);\n}\n\n.operator-kpi-card--cyan {\n  --kpi-accent: #0891b2;\n  --kpi-soft: rgba(8, 145, 178, 0.11);\n}\n\n.operator-kpi-card--blue {\n  --kpi-accent: #2563eb;\n  --kpi-soft: rgba(37, 99, 235, 0.11);\n}\n\n.operator-kpi-card--green {\n  --kpi-accent: #059669;\n  --kpi-soft: rgba(5, 150, 105, 0.11);\n}\n\n.operator-kpi-card--purple {\n  --kpi-accent: #7c3aed;\n  --kpi-soft: rgba(124, 58, 237, 0.11);\n}\n\n.operator-kpi-card--red {\n  --kpi-accent: #dc2626;\n  --kpi-soft: rgba(220, 38, 38, 0.1);\n}\n\n.operator-kpi-card__top {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.operator-kpi-card__eyebrow {\n  color: var(--kpi-accent);\n  font-size: 14px;\n  font-weight: 850;\n  letter-spacing: 1.15px;\n}\n\n.operator-kpi-card__icon {\n  display: grid;\n  place-items: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 11px;\n  background: var(--kpi-soft);\n  color: var(--kpi-accent);\n\n  svg {\n    width: 18px;\n    height: 18px;\n    fill: none;\n    stroke: currentColor;\n    stroke-width: 1.8;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n  }\n}\n\n.operator-kpi-card__label {\n  display: block;\n  position: relative;\n  z-index: 2;\n  margin-top: 8px;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.operator-kpi-card__glow {\n  position: absolute;\n  width: 120px;\n  height: 120px;\n  right: -48px;\n  bottom: -62px;\n  border-radius: 50%;\n  background: var(--kpi-soft);\n  filter: blur(4px);\n}\n\n@keyframes operator-kpi-enter {\n  from {\n    opacity: 0;\n    transform: translateY(14px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
